import React, { ReactElement, useEffect, useState } from 'react';
import { Button, FormText } from '@milanote/roma';

import { Content } from '../../../../../../mobile/structural/sheet';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { getLabelUsageData } from '../../../../../../element/labels/labelsService';
import { LabeledElementsData } from '../../../../../../../common/api/labels/labelElementsRetrievalRouteTypes';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import LabelColorPicker from '../components/LabelColorPicker';

import '../../colorTools/popup/mobile/MobileColorToolContent.scss';

type LabelEditSheetDetailsProps = {
    label: Label;
    onDeleteClick: () => void;
};

const LabelEditSheetContent = ({ label, onDeleteClick }: LabelEditSheetDetailsProps): ReactElement => {
    const translate = useTranslator('popup', 'labels.edit');
    const [labeledElements, setLabeledElements] = useState<LabeledElementsData[]>([]);

    useEffect(() => {
        getLabelUsageData(label._id).then(setLabeledElements);
    }, [label._id]);

    const labelUsageText = translate(
        'used',
        { count: labeledElements.length },
        {
            components: {
                usageLink: <a href="#" onClick={(event) => event.preventDefault()} />,
            },
        },
    );

    return (
        <Content>
            <LabelColorPicker label={label} />

            <div className="px-6 pb-6">
                <div className="mt-6">
                    <Button
                        color="tertiary-destructive"
                        size="md"
                        className="justify-start p-0"
                        onClick={onDeleteClick}
                    >
                        {translate('delete')}
                    </Button>
                </div>

                <FormText size="sm" color="quaternary" className="mt-3">
                    {labelUsageText}
                </FormText>
            </div>
        </Content>
    );
};

export default LabelEditSheetContent;
